import { paymentManagementService } from "@/data/repositories/repository";
import store from "@/store";

const DATE_FIELDS = new Set([
    "tripStartedFrom", "tripStartedTo",
    "tripEndedFrom", "tripEndedTo",
    "modifiedFrom", "modifiedTo"
]);

const PII_FIELDS = new Set([
    "ssn", "orderId", "cardNumber",
    "taximeterSerialNumber", "referenceNumber",
    "operatorId", "kelaBatchId"
]);

async function buildUsagePayload(tenantId, filters) {
    const entries = Object.entries(filters).filter(([, v]) =>
        v !== undefined && v !== null && v !== "" && !(Array.isArray(v) && v.length === 0)
    );

    const activeFields = entries.map(([k]) => k);

    const nonDateNonPii = Object.fromEntries(
        entries.filter(([k]) => !DATE_FIELDS.has(k) && !PII_FIELDS.has(k))
    );

    const hashInput = JSON.stringify(
        Object.fromEntries(Object.entries(nonDateNonPii).sort())
    );

    const hashBuffer = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(hashInput));
    const filterHash = Array.from(new Uint8Array(hashBuffer))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");

    return {
        tenantId,
        filterHash,
        filterFields: activeFields.join(","),
        filterNonDateValues: nonDateNonPii
    };
}

/**
 * Fire-and-forget: records filter usage for top-N analytics.
 * Silently swallows all errors — never affects the main search flow.
 */
export function trackFilterUsage(filters) {
    const tenantId = store.getters["user/tenantId"];
    if (!tenantId || !filters || Object.keys(filters).length === 0) return;

    buildUsagePayload(tenantId, filters).then((payload) => {
        return paymentManagementService.post("v1/filter-presets/usage", payload);
    }).catch(() => {
        // intentionally silent
    });
}
